import React, { PropTypes } from 'react';
import classnames from 'classnames';

import Sprite from 'components/shared/sprite.jsx';


class Menu extends React.Component {
	state = {
		isOpen: false
	};

  render() {
		const menuOpen = this.state.isOpen;
		const menuClasses = classnames({
			'menu': true,
			'menu-open': menuOpen,
		});
		const toggleButtonClasses = classnames(
			'menu-panel__toggle-button',
      menuOpen && 'menu-panel__toggle-button--opened'
		);

    return (
			<div className={menuClasses}>
				<div className="menu-brand">
					<Sprite className="menu-brand__logo" group="brand" symbol="logo" />
				</div>
				<div className="menu-panel">
					<div className="menu-panel__open-menu">
						<button
							className={toggleButtonClasses}
							type="button"
							onClick={() => this.setState({ isOpen: !this.state.isOpen})}
						>
							<div className="menu-panel__bar-item"></div>
							<div className="menu-panel__bar-item"></div>
							<div className="menu-panel__bar-item"></div>
						</button>
					</div>
					<div className="menu-panel__inner">
						<span>Undergoing some cosmetic surgery</span>
					</div>
				</div>
			</div>
    )
  }
}


export default Menu;



/** WEBPACK FOOTER **
 ** ./src/app/components/ui/menu/Menu.jsx
 **/